import { z } from "zod";

import { PLACE_OF_SERVICE_OPTIONS } from "@/billing/constants/place-of-service";

const placeOfServiceValues = PLACE_OF_SERVICE_OPTIONS.map((option) => option.value) as [
  (typeof PLACE_OF_SERVICE_OPTIONS)[number]["value"],
  ...(typeof PLACE_OF_SERVICE_OPTIONS)[number]["value"][],
];

/**
 * Zod schema for the Update Location drawer.
 *
 * Unlike the Add Service drawer's own `placeOfService` field, this one is required: the drawer
 * supports setting an initially absent Location as well as replacing an existing one, and either
 * way the biller must leave it with a value chosen.
 */
export const updateLocationFormSchema = z.object({
  placeOfService: z.enum(placeOfServiceValues, { required_error: "Location is required" }),
});
